// extracted by mini-css-extract-plugin
export default {"root":"IconPlusUser_root__+GxBC"};